var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    {
      attrs: {
        content: _vm.content,
        disabled: _vm.isShowTooltip,
        effect: _vm.effect,
        placement: _vm.placement,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            overflow: "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap",
          },
          on: {
            mouseover: function ($event) {
              return _vm.onMouseOver(_vm.content)
            },
          },
        },
        [
          _c("span", { ref: _vm.content, class: _vm.contentClass }, [
            _vm._v(_vm._s(_vm.content)),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }